<template>
    <div style="width: 95%;">
      <template v-if="!newVisit">
        <template v-if="loading>0">
          <Loader :delay="0"></Loader>
        </template>
        <template v-else>
          <b-table v-if="visits.length>0" striped hover :items="visits" :fields="table_fields">
            <template slot="id_resultado_visita" slot-scope="row">
              {{parseResult(row.item.id_resultado_visita)}}
            </template>
            <template slot="fecha_hora_visita" slot-scope="row">
              {{parseDateTime(row.item.fecha_hora_visita)}}
            </template>
            <template slot="fecha_hora_proxima_visita" slot-scope="row">
              {{parseDateTime(row.item.fecha_hora_proxima_visita)}}
            </template>
            <template slot="actions" slot-scope="row">
              <b-dropdown variant="link" no-caret>
                <template slot="button-content"><i class="fa fa-ellipsis-v" aria-hidden="true"></i></template>
                <b-dropdown-item-button @click="deleteVisit(row.item)" v-if="hasPermision('E')">Eliminar</b-dropdown-item-button>
                <b-dropdown-item-button @click="editVisit(row.item)" v-if="hasPermision('E')">Editar</b-dropdown-item-button>
              </b-dropdown>
            </template>
          </b-table>
          <template v-else>
            <br>
            <span style="color:red"><strong>No se han encontrado visitas.</strong></span>
          </template>
          <br><br>
          <b-row>
            <b-col v-if="hasPermision('E')">
              <b-button @click="createNewVisit">Añadir visita</b-button>
            </b-col>
          </b-row>
        </template>
      </template>
      <template v-else-if="firstStep">
        <b-row>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Código visitador">
                <!-- <b-form-input value="" disabled></b-form-input> -->
                <b-form-select @input="updateUser" v-model="currentUser" :options="users_options" class="mb-3" text-field="username" value-field="username"/>
              </b-form-group>
            </b-form>
          </b-col>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Nombre visitador">
                <input class="form-control" :value="user.first_name + ' ' + user.last_name" disabled>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Visitado por gestor">
                <!-- <b-form-input v-model="visit.visitado_gestor"></b-form-input> -->
                <div class="form-control" >
                  <switches
                  v-model="visit.visitado_gestor"
                  style="margin-top: .5rem;"
                  color="blue">
                  </switches>
                  &nbsp;
                  <span v-if="visit.visitado_gestor">
                    Sí
                  </span>
                  <span v-else>
                    No
                  </span>
                </div>
              </b-form-group>
            </b-form>
          </b-col>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Status">
                <!-- <b-form-input v-model="visit.status_visita"></b-form-input> -->
                <b-form-select v-validate="'required'" name="Status" v-model="visit.status_visita" :options="status_options" class="mb-3" text-field="visita_status" value-field="visita_status"/>
                <span class="error">{{ errors.first('Status') }}</span>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Fecha y hora planificada">
                <!-- <b-form-input v-model="visit.fecha_hora_visita" :disabled="!visit.status_visita"></b-form-input> -->
                <b-input-group>
                  <datetime
                  v-validate="(visit.status_visita === 'PLANIFICADA' || visit.status_visita === 'CANCELADA') ? 'required':''"
                  name="Fecha y hora planificada"
                  v-model="visit.fecha_hora_proxima_visita"
                  input-class="form-control"
                  :phrases="{ok: 'Ok', cancel: 'Cancelar'}"
                  type="datetime"
                  :auto="true"
                  :minute-step="15"
                  value-zone="local"
                  zone="local">
                  </datetime>
                  <b-input-group-text slot="append" @click="visit.fecha_hora_proxima_visita = ''">
                    <strong class="text-danger"><i class="fa fa-times"></i></strong>
                  </b-input-group-text>
                </b-input-group>
                <span class="error">{{ errors.first('Fecha y hora planificada') }}</span>
              </b-form-group>
            </b-form>
          </b-col>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Fecha y hora finalizada">
                <!-- <b-form-input v-model="visit.fecha_hora_visita" :disabled="!visit.status_visita"></b-form-input> -->
                <b-input-group>
                  <datetime
                  v-validate="(visit.status_visita === 'FINALIZADA') ? 'required':''"
                  name="Fecha y hora finalizada"
                  v-model="visit.fecha_hora_visita"
                  input-class="form-control"
                  :phrases="{ok: 'Ok', cancel: 'Cancelar'}"
                  type="datetime"
                  :auto="true"
                  :minute-step="15"
                  value-zone="local"
                  :max-datetime="currentDate"
                  zone="local">
                  </datetime>
                  <b-input-group-text slot="append" @click="visit.fecha_hora_visita = ''">
                    <strong class="text-danger"><i class="fa fa-times"></i></strong>
                  </b-input-group-text>
                </b-input-group>
                <span class="error">{{ errors.first('Fecha y hora finalizada') }}</span>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Tipo actividad">
                <!-- <b-form-input v-model="visit.tipo_actividades"></b-form-input> -->
                <b-form-select v-validate="'required'" name="Tipo actividad" v-model="visit.tipo_actividad" :options="tipo_actividad_options" class="mb-3" text-field="descripcion" value-field="descripcion"/>
                <span class="error">{{ errors.first('Tipo actividad') }}</span>
              </b-form-group>
            </b-form>
          </b-col>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Resultado">
                <!-- <b-form-input v-model="visit.id_resultado_visita"></b-form-input> -->
                <b-form-select v-validate="(visit.status_visita === 'FINALIZADA') ? 'required':''" name="Resultado" v-model="visit.id_resultado_visita" :options="resultados_options" class="mb-3" text-field="resultado" value-field="id"/>
                <span class="error">{{ errors.first('Resultado') }}</span>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Observaciones">
                <b-form-input v-validate="ObsValidate" name="Observaciones" v-model="visit.observaciones"></b-form-input>
                <span class="error">{{ errors.first('Observaciones') }}</span>
              </b-form-group>
            </b-form>
          </b-col>
          </b-row>
          <b-row>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Invitados">
                <b-form-input v-model="visit.invitados"></b-form-input>
              </b-form-group>
            </b-form>
          </b-col>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Enviar email a invitados">
                <a class="btn btn-secondary" target="_top" :href="mailText">Enviar</a>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
        <b-row>
          <b-col style="text-align: right;" v-if="hasPermision('E')">
            <b-button @click="newVisit = false">Cancelar</b-button>
            <b-button @click="saveStep">Guardar</b-button>
          </b-col>
        </b-row>
      </template>
      <template v-else>
        <template v-if="loading>0">
          <Loader :delay="0"></Loader>
        </template>
        <template v-else>
          <h2>
            Actualización datos gestión
          </h2>
          <b-row>
            <b-col>
              <b-form>
                    <b-form-group style="font-size: 1rem;" label="Clase establecimiento GN">
                      <b-form-select v-validate="'required'" name="Clase establecimiento GN" v-model="detalles['id_clase_establecimiento_gn_'+type].id" :options="clase_establecimiento_comercial_options" class="mb-3" text-field="tipo" value-field="id"/>
                      <span class="error">{{ errors.first('Clase establecimiento GN') }}</span>
                    </b-form-group>
                  </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Es cliente">
                  <b-form-select v-validate="isRequired" name="Es cliente" v-model="detalles.cliente" :options="cliente_options" class="mb-3" text-field="text" value-field="value" :disabled="!hasPermision('E')"/>
                  <span class="error">{{ errors.first('Es cliente') }}</span>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col v-if="type==='comercial'">
              <!-- TODO: no sense this if -->
              <b-form>
                  <b-form-group v-if="type==='comercial'" style="font-size: 1rem;" label="Gas en finca">
                    <b-form-select v-validate="checkGasEnFinca" name="Gas en finca" v-model="detalles.id_gas_finca.id" :options="gas_options" class="mb-3" text-field="gas" value-field="id" :disabled="!hasPermision('E')"/>
                    <span class="error">{{ errors.first('Gas en finca') }}</span>
                  </b-form-group>
                  <b-form-group v-if="type==='caldera'" style="font-size: 1rem;" label="Gas en finca">
                    <b-form-select v-validate="checkGasEnFinca" name="Gas en finca" v-model="detalles.id_gas_en_finca.id" :options="gas_options" class="mb-3" text-field="gas" value-field="id" :disabled="!hasPermision('E')"/>
                    <span class="error">{{ errors.first('Gas en finca') }}</span>
                  </b-form-group>
                </b-form>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
                <b-form>
                  <b-form-group style="font-size: 1rem;" label="Status gestión">
                    <b-form-select @input="updateDate" v-validate="'required'" name="Status gestión" v-model="detalles['id_status_gestion_'+type].id" :options="status_gestion_options" class="mb-3" text-field="status" value-field="id"/>
                    <span class="error">{{ errors.first('Status gestión') }}</span>
                  </b-form-group>
                </b-form>
            </b-col>
            <b-col>
                <b-form v-if="detalles['id_status_gestion_'+type].id === 5">
                  <b-form-group style="font-size: 1rem;" label="Motivo rechazo">
                  <b-form-select v-validate="'required'" name="Motivo rechazo" v-model="detalles.motivo_rechazo" :options="motivo_rechazo_options" class="mb-3" text-field="motivo" value-field="motivo" :disabled="!hasPermision('E')"/>
                    <span class="error">{{ errors.first('Motivo rechazo') }}</span>
                  </b-form-group>
                </b-form>
                <b-form v-else-if="detalles['id_status_gestion_'+type].id === 8">
                  <b-form-group style="font-size: 1rem;" label="Motivo no potencial">
                  <b-form-select v-validate="'required'" name="Motivo no potencial" v-model="detalles.motivo_no_potencial" :options="motivo_no_potencial_options" class="mb-3" text-field="motivo" value-field="motivo" :disabled="!hasPermision('E')"/>
                    <span class="error">{{ errors.first('Motivo no potencial') }}</span>
                  </b-form-group>
                </b-form>
            </b-col>
          </b-row>
          <b-row>
            <b-col style="text-align: right;" v-if="hasPermision('E')">
              <b-button @click="firstStep = true">Cancelar</b-button>
              <b-button @click="saveVisit">Guardar</b-button>
            </b-col>
          </b-row>
        </template>
      </template>
    </div>
</template>

<script>
import Switches from 'vue-switches';
import Vue from 'vue';
import Loader from '@/components/Layout/Loader.vue';
import moment from 'moment';

export default {
  inject: {
    $validator: '$validator'
  },
  name: 'ComercialVisitas',
  props: ['feature', 'type', 'permisos'],
  components: {
    Loader,
    Switches
  },
  data () {
    return {
      newVisit: false,
      motivo_no_potencial_options: [],
      motivo_rechazo_options: [],
      cliente_options: [{value: null, text: ''}, {value: true, text: 'Sí'}, {value: false, text: 'No'}],
      mail: '',
      table_fields: [
        { key: 'actions', label: 'Acciones' },
        { key: 'fecha_hora_visita', label: 'Fecha realizada' },
        { key: 'fecha_hora_proxima_visita', label: 'Fecha planificada' },
        { key: 'codigo_visitador', label: 'Gestor' },
        { key: 'status_visita', label: 'Status' },
        { key: 'tipo_actividad', label: 'Tipo actividad' },
        { key: 'id_resultado_visita', label: 'Resultado' },
        { key: 'observaciones', label: 'Observaciones' }
      ],
      visits: [],
      clase_establecimiento_comercial_options: [],
      loading: 0,
      firstStep: true,
      gas_options: [],
      visit: {
        id: null,
        id_comercial: this.feature.properties.id,
        id_caldera: this.feature.properties.id,
        status_visita: null,
        fecha_hora_visita: null,
        tipo_actividades: null,
        id_resultado_visita: null,
        observaciones: null,
        visitado_gestor: true,
        codigo_visitador: null,
        fecha_hora_proxima_visita: null
      },
      currentUser: null,
      status_options: [],
      status_gestion_options: [],
      tipo_actividad_options: [],
      resultados_options: [],
      user: null,
      users_options: [],
      endpoint: '',
      detalles: null
    };
  },
  computed: {
    currentDate: function () {
      return moment().format();
    },
    isRequired: function () {
      if (this.detalles['id_status_gestion_' + this.type].id === 8 && this.detalles.motivo_no_potencial === 'Ya es cliente') {
        return 'required:true';
      } else {
        return 'required';
      }
    },
    checkGasEnFinca: function () {
      if (this.detalles.cliente) {
        return {'is': 1};
      } else {
        return 'required';
      }
    },
    ObsValidate: function () {
      if (this.visit.status_visita === 'FINALIZADA') {
        return 'required|max:1000';
      } else {
        return 'max:1000';
      }
    },
    noPotencialValidate: function () {
      if (this.detalles['id_status_gestion_' + this.type].id === 8) {
        return {required: true};
      } else {
        return {is: null};
      }
    },
    mailText: function () {
      var subject = '[Cita Geovisor] ';
      if (this.type === 'comercial') {
        subject = subject + 'CRM COMERCIAL: ';
      } else {
        subject = subject + 'CRM CALDERA CENTRALIZADA: ';
      }
      subject = subject + '[' + encodeURIComponent(this.visit.status_visita) + '] – ';
      subject = subject + '[' + encodeURIComponent(this.feature.properties.direccion_no_estructurada) + ']';

      return 'mailto:' + this.mail + '?subject=' + subject;
    }
  },
  mounted: function () {
    this.loading = 1;
    this.$http.get('tokens/' + Vue.cookie.get('kernel_token') + '/').then(response => {
      this.user = response.data.user;
      this.currentUser = this.user.username;

      if (this.type === 'comercial') {
        this.endpoint = 'comercial_visitas/';
      } else {
        this.endpoint = 'caldera_visitas/';
      }

      var id = this.feature.id.split('.')[1];
      if (this.type === 'caldera') {
        id = this.feature.properties.id;
      }
      this.$http.get(this.type + '/' + id + '/').then(result => {
        this.initLists();
        this.getVisits();
        this.detalles = result.data;
        this.loading = this.loading - 1;
      });
    });
  },
  methods: {
    updateDate: function () {
      this.detalles.fecha_cambio_status = moment().format('YYYY-MM-DD');
    },
    parseDateTime: function (date) {
      if (!date) {
        return '';
      } else {
        return moment(date).format('DD/MM/YYYY HH:mm');
      }
    },
    parseResult: function (id) {
      var filter = this.resultados_options.find(e => e.id === id);
      if (filter) {
        return filter.resultado;
      } else {
        return null;
      }
    },
    hasPermision: function (p) {
      var rol = '';
      if (this.type === 'caldera') {
        rol = 'CALDERA CENTRALIZADA';
      } else {
        rol = 'COMERCIAL';
      }
      return this.permisos[rol][p];
    },
    updateUser: function () {
      this.user = this.users_options.filter(e => e.username === this.currentUser)[0];
    },
    initLists: function () {
      Promise.all([
        this.$http.get('status_visitas/', {params: {not_paginated: true}}),
        this.$http.get('tipo_actividad_visitas_' + this.type + '/', {params: {not_paginated: true}}),
        this.$http.get('resultados_visitas/', {params: {not_paginated: true}}),
        this.$http.get('users2/', {params: {not_paginated: true}}),
        this.$http.get('clase_establecimiento_comercial/', {params: {not_paginated: true}}),
        this.$http.get('gas_finca/', {params: {not_paginated: true}}),
        this.$http.get('status_gestion_' + this.type + '/', {params: {not_paginated: true}}),
        this.$http.get('motivo_no_potencial_comercial/', {params: {not_paginated: true}}),
        this.$http.get('motivo_rechazo_comercial/', {params: {not_paginated: true}})
      ]).then(results => {
        this.status_options = [{id: null, visita_status: ''}].concat(results[0].data);
        this.tipo_actividad_options = [{id: null, descripcion: ''}].concat(results[1].data);
        this.resultados_options = [{id: null, resultado: ''}].concat(results[2].data);
        this.users_options = results[3].data;
        this.clase_establecimiento_comercial_options = [{id: null, tipo: ''}].concat(results[4].data);
        this.gas_options = [{id: null, gas: ''}].concat(results[5].data);
        this.status_gestion_options = [{id: null, status: ''}].concat(results[6].data);
        this.motivo_no_potencial_options = [{id: null, motivo: ''}].concat(results[7].data);
        this.motivo_rechazo_options = [{id: null, motivo: ''}].concat(results[8].data);

        if (this.detalles.motivo_no_potencial && this.motivo_no_potencial_options.findIndex(e => e.motivo === this.detalles.motivo_no_potencial) < 0) {
          this.motivo_no_potencial_options = this.motivo_no_potencial_options.concat([{id: 999, motivo: this.detalles.motivo_no_potencial}]);
        }
        if (this.detalles.motivo_rechazo && this.motivo_rechazo_options.findIndex(e => e.motivo === this.detalles.motivo_rechazo) < 0) {
          this.motivo_rechazo_options = this.motivo_rechazo_options.concat([{id: 999, motivo: this.detalles.motivo_rechazo}]);
        }

        this.user = this.users_options.filter(e => e.id === this.user.id)[0];
      });
    },
    editVisit: function (visit) {
      this.visit = visit;

      // this.user = this.users_options.filter(e => e.username === this.visit.codigo_visitador)[0]
      this.currentUser = this.visit.codigo_visitador;
      this.updateUser();

      this.newVisit = true;
    },
    createNewVisit: function () {
      this.$http.get('tokens/' + Vue.cookie.get('kernel_token') + '/').then(response => {
        this.user = response.data.user;
        this.currentUser = this.user.username;

        var tipo = null;
        if (this.type === 'caldera') {
          tipo = 'VISITA COMUNIDAD PROPIETARIOS';
        } else {
          tipo = 'VISITA CLIENTE GCO';
        }
        this.visit = {
          id: null,
          id_comercial: this.feature.properties.id,
          id_caldera: this.feature.properties.id,
          status_visita: null,
          fecha_hora_visita: null,
          fecha_hora_proxima_visita: null,
          tipo_actividad: tipo,
          id_resultado_visita: null,
          observaciones: null,
          visitado_gestor: true,
          codigo_visitador: this.user.username,
          invitados: ''
        };
        this.newVisit = true;
      });
    },
    saveStep: function () {
      this.$validator.validate().then(result => {
        if (!result) {
          alert('Tienes algún error en el formulario');
        } else {
          this.firstStep = false;
        }
      });
    },
    saveVisit: function () {
      this.$validator.validate().then(result => {
        if (!result) {
          alert('Tienes algún error en el formulario');
        } else {
          this.visit.codigo_visitador = this.currentUser;

          if (this.detalles['id_status_gestion_' + this.type].id !== 8) {
            this.detalles.motivo_no_potencial = null;
          }
          if (this.detalles['id_status_gestion_' + this.type].id !== 5) {
            this.detalles.motivo_rechazo = null;
          }

          if (this.visit.id_comercial_id) {
            this.visit.id_comercial = this.visit.id_comercial_id;
          }
          if (this.visit.id_caldera_id) {
            this.visit.id_caldera = this.visit.id_caldera_id;
          }

          if (this.visit.fecha_hora_proxima_visita) {
            this.visit.fecha_hora_proxima_visita = this.visit.fecha_hora_proxima_visita.split('+')[0] + '+00:00';
          } else if (this.visit.fecha_hora_proxima_visita === '') {
            this.visit.fecha_hora_proxima_visita = null;
          }
          if (this.visit.fecha_hora_visita) {
            this.visit.fecha_hora_visita = this.visit.fecha_hora_visita.split('+')[0] + '+00:00';
          } else if (this.visit.fecha_hora_visita === '') {
            this.visit.fecha_hora_visita = null;
          }

          var th = this;
          this.loading = this.loading + 1;
          this.$http.put(this.type + '2/' + this.detalles.id + '/', this.detalles).then(result => {
            if (th.visit.id) {
              th.$http.put(th.endpoint + th.visit.id + '/', th.visit).then(result => {
                th.getVisits();
                th.loading = th.loading - 1;

                if (th.type === 'comercial') {
                  th.$emit('comercialSaved');
                } else {
                  th.$emit('calderaSaved');
                }
              });
            } else {
              th.$http.post(th.endpoint, th.visit).then(result => {
                th.getVisits();
                th.loading = th.loading - 1;

                if (th.type === 'comercial') {
                  th.$emit('comercialSaved');
                } else {
                  th.$emit('calderaSaved');
                }
              });
            }

            th.feature.properties['id_clase_establecimiento_gn_' + th.type] = th.detalles['id_clase_establecimiento_gn_' + th.type];
            th.feature.properties.cliente = th.detalles.cliente;
            th.feature.properties['id_status_gestion_' + th.type] = th.detalles['id_status_gestion_' + th.type];
            if (th.type === 'comercial') {
              th.feature.properties.id_gas_finca = th.detalles.id_gas_finca;
            }
          });
        }
      });
    },
    deleteVisit: function (visit) {
      this.$http.delete(this.endpoint + visit.id).then(result => {
        this.getVisits();
      });
    },
    getVisits: function () {
      this.loading = this.loading + 1;
      var params = {not_paginated: true};
      if (this.hasPermision('A')) {
        params.create_user = this.currentUser;
      }
      if (this.type === 'comercial') {
        params.id_comercial = this.feature.properties.id;
        this.$http.get(this.endpoint, {params: params}).then(result => {
          this.visits = result.data;
          this.loading = this.loading - 1;
          this.firstStep = true;
          this.newVisit = false;
        });
      } else {
        params.id_caldera = this.feature.properties.id;
        this.$http.get(this.endpoint, {params: params}).then(result => {
          this.visits = result.data;
          this.loading = this.loading - 1;
          this.firstStep = true;
          this.newVisit = false;
        });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Modules/Map/Details/comercial_visitas.vue